import React, { FC } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '../Checkbox';

export interface RHFSwitchProps {
  name: string;
  label: string;
  labelPlacement?: 'end' | 'bottom' | 'start' | 'top' | 'none';
  style?: any;
  RHFChangeHandler?: () => {};
}

export const RHFSwitch: FC<RHFSwitchProps> = ({
  name,
  label,
  labelPlacement = 'end',
  style = {},
  RHFChangeHandler,
}: RHFSwitchProps) => {
  const methods = useFormContext();

  if (labelPlacement === 'none') {
    return (
      <Controller
        name={name}
        control={methods.control}
        render={({ field: props }) => (
          <Switch
            {...props}
            color="primary"
            checked={!!props.value}
            onChange={e => {
              props.onChange(e.target.checked);
              if (RHFChangeHandler) {
                RHFChangeHandler();
              }
            }}
            style={style}
          />
        )}
      />
    );
  }

  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={methods.control}
          render={({ field: props }) => (
            <Checkbox
              {...props}
              color="primary"
              checked={!!props.value}
              onChange={e => props.onChange(e.target.checked)}
              style={style}
            />
          )}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};
